function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreYouSure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.93,387.56c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46l0-11.19v-.5h.5l17.58.07c4.38,0,13.2.14,17.58.2h.24v.23l-.24,11.19Zm0,0-.24-11.19.24.24c-4.39.06-13.2.16-17.58.2l-17.58.06.5-.5,0,11.19-.46-.45,8.71,0c5.57.07,20.68.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.6,268.13c-5.86.11-20.63.35-26.29.42l-8.87,0H129v-.46L128.94,257v-.51h.5l17.58.06c4.38,0,13.2.14,17.58.2h.24V257l-.24,11.18Zm0,0L164.36,257l.24.23c-4.38.06-13.19.16-17.58.2l-17.58.06.5-.49,0,11.18-.46-.45,8.71,0c5.58.07,20.69.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.32,401.67c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46l0-11.19V390h.5l17.58.07c4.37,0,13.2.13,17.58.2h.24v.23l-.23,11.19Zm0,0-.24-11.19.24.24c-4.39.06-13.2.16-17.58.2L53.16,391l.5-.5,0,11.19-.46-.45,8.71,0c5.57.07,20.68.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.72,150.16c-5.85.1-20.62.35-26.29.42l-8.86,0h-.46v-.46l0-11.19v-.5h.51l17.57.07c4.38,0,13.21.14,17.58.2H343V139l-.24,11.19Zm0,0L342.49,139l.23.24c-4.38.06-13.19.16-17.58.2l-17.57.06.49-.5,0,11.19-.45-.45,8.71,0c5.57.07,20.68.32,26.44.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.11,164.27c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46l-.05-11.19v-.5h.5l17.58.07c4.38,0,13.2.13,17.58.2h.24v.23l-.24,11.19Zm0,0-.24-11.19.24.24c-4.39.06-13.19.16-17.58.2l-17.58.06.5-.5,0,11.19-.46-.45,8.71,0c5.58.07,20.69.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.58,150.16c-5.86.1-20.63.35-26.29.42l-8.87,0H268v-.46l0-11.19v-.5h.5l17.58.07c4.37,0,13.2.14,17.58.2h.24V139l-.23,11.19Zm0,0L303.34,139l.24.24c-4.39.06-13.2.16-17.58.2l-17.58.06.5-.5-.05,11.19-.45-.45,8.71,0c5.57.07,20.68.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.84,401.67c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46l-.05-11.19V390h.5l17.58.07c4.38,0,13.2.13,17.58.2h.24v.23l-.24,11.19Zm0,0-.24-11.19.24.24c-4.39.06-13.19.16-17.58.2l-17.58.06.5-.5,0,11.19-.46-.45,8.71,0c5.58.07,20.69.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.23,56.12c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46l-.05-11.19v-.5h.5l17.58.07c4.38,0,13.2.13,17.58.2h.24v.23l-.24,11.19Zm0,0L427,44.93l.24.24-8.79.11c-5.58.08-20.6.13-26.37.15l.5-.5,0,11.19-.46-.45,8.71,0c5.57.06,20.68.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.84,70.23c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46L411.18,59v-.5h.5l17.58.07c4.38,0,13.2.13,17.58.2h.24V59l-.24,11.19Zm0,0L446.6,59l.24.24c-4.39.06-13.19.16-17.58.19l-17.58.07.5-.5,0,11.19-.46-.45,8.71,0c5.58.06,20.69.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93,56.12c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46l0-11.19v-.5h.5l17.58.07c4.38,0,13.2.13,17.58.2h.24v.23l-.24,11.19Zm0,0-.24-11.19.24.24c-4.39.06-13.2.16-17.58.19l-17.58.07.5-.5,0,11.19-.46-.45,8.71,0c5.57.06,20.68.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.06,
    y: 66.52,
    width: 66.33,
    height: 66.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.61,63.07v73.24h73.23V63.07Zm3.45,3.45H437.4v66.34H371.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.22,
    y: 82.7,
    width: 22.93,
    height: 51.7,
    transform: "translate(510.23 -293.14) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.98,
    y: 86.45,
    width: 26.49,
    height: 26.49,
    transform: "translate(503.92 -304.54) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.78,
    y: 63.07,
    width: 2.83,
    height: 73.24,
    transform: "translate(732.39 199.38) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.06,
    y: 160.71,
    width: 66.33,
    height: 66.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.67,
    y: 171.32,
    width: 17.32,
    height: 50.03,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.61,157.26v73.23h73.23V157.26Zm3.45,3.45H437.4V227H371.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.99,
    y: 180.63,
    width: 26.49,
    height: 26.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.78,
    y: 157.26,
    width: 2.83,
    height: 73.24,
    transform: "translate(732.39 387.75) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.06,
    y: 254.9,
    width: 66.33,
    height: 66.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.64,
    y: 263.94,
    width: 36.4,
    height: 21.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.61,251.45v73.23h73.23V251.45Zm3.45,3.45H437.4v66.33H371.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.99,
    y: 274.82,
    width: 26.49,
    height: 26.49,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.78,
    y: 251.45,
    width: 2.83,
    height: 73.24,
    transform: "translate(732.39 576.13) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.54,55.17V300.88H223.25V55.17Zm5.9,5.9H217.35V295H69.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.44,
    y: 61.07,
    width: 147.92,
    height: 233.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.44,
    y: 175.08,
    width: 147.92,
    height: 5.89,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7,
    y: 300.88,
    width: 181.41,
    height: 16.91,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.36,212.4H69.44V61.06H217.36ZM74.9,207h137V66.52H74.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.65,
    y: 61.06,
    width: 2.95,
    height: 145.89,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.21,
    y: 61.06,
    width: 2.95,
    height: 145.89,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.81,328.57s-9.64-7.28-5.34-10.57c1.5-1.14,4.85,2.48,5.34,6.52.49-4,3.84-7.66,5.34-6.52C414.45,321.29,404.81,328.57,404.81,328.57Z",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,328.57s-9.64-7.28-5.34-10.57c1.5-1.14,4.85,2.48,5.34,6.52.49-4,3.84-7.66,5.34-6.52C414.45,321.29,404.81,328.57,404.81,328.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,328.57c-5.82,0-10.14-5.3-8.82-7.61,1.5-2.63,6.73,3.56,6.73,3.56s-2-8.75,2.09-8.75,2.09,8.75,2.09,8.75,5.24-6.19,6.74-3.56C415,323.27,410.63,328.57,404.81,328.57Z",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.36,391.06l-.94,21.22c-3.46.31-15.25-3-20.9-8.65-4.25-4.25-3.14-17.44-.78-33.78s7.07-18.23,11-17.29a5.84,5.84,0,0,1,2.48,1.26c2.09,1.81,3,5.21,3.34,9.59.47,5.81-1.89,21.06-1.26,24.67a3.09,3.09,0,0,0,1.49,2.19C384.58,391.38,387.44,391.06,388.36,391.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.88,420.49s-16.74,6.12-34.18,0c0,0,1.65-67.42,3.77-78.73S397.39,325,405.08,325a14.41,14.41,0,0,1,1.49.08c6.13.65,10.4,5.35,11.71,14.3,1,6.86,1.89,44.79,2.32,66.26C420.78,414.45,420.88,420.49,420.88,420.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.07,382.15c-5.66,5.65-17.45,9-20.9,8.64l-.94-21.22c1.29,0,6.44.63,7.07-3s-1.73-18.86-1.26-24.67,1.88-9.9,5.82-10.85a6.59,6.59,0,0,1,1-.16c3.71-.36,7.84,2.47,10,17.45a190.67,190.67,0,0,1,2,19.28C444.14,374.59,443.44,379.77,441.07,382.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,325a1.14,1.14,0,0,1,.73.23,3.18,3.18,0,0,1,.58.52A7.15,7.15,0,0,1,407,327a17.58,17.58,0,0,1,1.15,2.89,48.22,48.22,0,0,1,1.4,6.05c.68,4.09,1.06,8.21,1.35,12.34s.41,8.26.49,12.39l.23,12.38c.09,8.26.22,16.52.27,24.77l.06,12.39c0,4.13,0,8.26-.05,12.39-.17-4.13-.28-8.26-.42-12.38l-.32-12.39c-.2-8.25-.32-16.51-.48-24.76s-.1-16.52-.49-24.75c-.21-4.12-.51-8.23-1.09-12.31a47.57,47.57,0,0,0-1.19-6.05,17.58,17.58,0,0,0-1-2.9,6.71,6.71,0,0,0-.79-1.31,2.76,2.76,0,0,0-.54-.54A1.09,1.09,0,0,0,404.81,325Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,421.56c-.11-4.13-.17-8.26-.25-12.39l-.18-12.39L416.26,372q-.06-6.19-.2-12.38l-.08-3.1-.11-3.08c-.11-2.06-.26-4.12-.43-6.18s-.41-4.1-.7-6.14a54.31,54.31,0,0,0-1.18-6.05,21.68,21.68,0,0,0-2.29-5.7,12,12,0,0,0-1.92-2.4,10.1,10.1,0,0,0-2.54-1.73,10.06,10.06,0,0,1,2.61,1.66,11.69,11.69,0,0,1,2,2.37,22,22,0,0,1,2.45,5.71A71.46,71.46,0,0,1,416,347.21q.63,6.18.86,12.38t.3,12.4c.09,4.13.12,8.26.13,12.39l0,12.39-.11,12.39C417.14,413.3,417.07,417.43,417,421.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,325a1.11,1.11,0,0,0-.71.26,3.07,3.07,0,0,0-.54.54,6.71,6.71,0,0,0-.79,1.31,18.55,18.55,0,0,0-1,2.9,47.54,47.54,0,0,0-1.18,6.05c-.58,4.08-.89,8.19-1.09,12.31-.4,8.23-.37,16.49-.49,24.75s-.29,16.51-.49,24.76l-.32,12.39c-.14,4.12-.25,8.25-.42,12.38,0-4.13,0-8.26,0-12.39l.06-12.39c.05-8.25.18-16.51.27-24.77l.23-12.38c.07-4.13.18-8.27.48-12.39s.68-8.25,1.35-12.34a50,50,0,0,1,1.4-6.05,19.55,19.55,0,0,1,1.15-2.89,6.71,6.71,0,0,1,.87-1.3,3.12,3.12,0,0,1,.57-.52A1.15,1.15,0,0,1,404.81,325Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.67,421.56c-.12-4.13-.18-8.26-.25-12.4l-.11-12.39,0-12.39q0-6.19.13-12.39t.3-12.4q.23-6.19.85-12.38A71.48,71.48,0,0,1,395.75,335a21.7,21.7,0,0,1,2.45-5.71,11.64,11.64,0,0,1,2-2.37,10.23,10.23,0,0,1,2.61-1.66,10.28,10.28,0,0,0-2.54,1.73,12.34,12.34,0,0,0-1.92,2.4,21.65,21.65,0,0,0-2.28,5.7,52.12,52.12,0,0,0-1.18,6.05c-.3,2-.52,4.09-.7,6.14s-.33,4.12-.43,6.18l-.12,3.08-.07,3.1q-.15,6.18-.21,12.38l-.26,24.78-.18,12.39C392.85,413.3,392.78,417.43,392.67,421.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,423.17c-.1-4.09-.15-8.18-.23-12.27l-.13-12.28c-.08-8.18-.07-16.36-.11-24.54s0-16.37.11-24.55l.13-12.27c.08-4.09.13-8.18.23-12.28.11,4.1.16,8.19.23,12.28l.13,12.27c.08,8.18.08,16.37.11,24.55s0,16.36-.11,24.54L405,410.9C405,415,404.92,419.08,404.81,423.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.73,352.57a6.6,6.6,0,0,1,1.13,1.17,7.12,7.12,0,0,1,.79,1.43,13.89,13.89,0,0,1,.83,3.16,38.25,38.25,0,0,1,.29,6.5,121.14,121.14,0,0,1-1.19,12.92,63,63,0,0,0-.68,6.39,22.1,22.1,0,0,0,.47,6.3,8.52,8.52,0,0,0,1.25,2.84,5.88,5.88,0,0,0,1,1.15,6.36,6.36,0,0,0,1.28.89,10.61,10.61,0,0,0,3,1c1,.2,2.12.33,3.2.44a25.16,25.16,0,0,1-3.24-.2,10.7,10.7,0,0,1-3.16-.87,6.79,6.79,0,0,1-2.59-2.09,9,9,0,0,1-1.46-3,21.92,21.92,0,0,1-.65-6.54,63.72,63.72,0,0,1,.63-6.48q.47-3.19.82-6.4c.25-2.13.45-4.28.58-6.42a44.23,44.23,0,0,0,0-6.41,13.87,13.87,0,0,0-.61-3.13A6.57,6.57,0,0,0,376.73,352.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,352.37a2.06,2.06,0,0,0-.92.49,5.22,5.22,0,0,0-.72.77,9.83,9.83,0,0,0-1.1,1.81,22.52,22.52,0,0,0-1.44,4,60.52,60.52,0,0,0-1.57,8.35c-.68,5.64-1.34,11.3-1.52,17a48.51,48.51,0,0,0,.36,8.44,16,16,0,0,0,1.06,4,10.74,10.74,0,0,0,2.37,3.33,24.52,24.52,0,0,0,7,4.6,39.18,39.18,0,0,0,8.08,2.64,36.24,36.24,0,0,1-8.27-2.21,23.9,23.9,0,0,1-7.34-4.5,11.07,11.07,0,0,1-2.62-3.53,16.52,16.52,0,0,1-1.18-4.21,47.68,47.68,0,0,1-.42-8.6,151.55,151.55,0,0,1,1.74-17,56,56,0,0,1,1.86-8.38,23.26,23.26,0,0,1,1.65-4,10.16,10.16,0,0,1,1.21-1.78,5.47,5.47,0,0,1,.79-.73A2.1,2.1,0,0,1,376,352.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,331.07a6.69,6.69,0,0,0-1.68,2.7,13.87,13.87,0,0,0-.61,3.13,42.86,42.86,0,0,0,0,6.41c.13,2.14.33,4.28.57,6.42s.52,4.27.82,6.4a60.49,60.49,0,0,1,.64,6.48,21.6,21.6,0,0,1-.66,6.54,9.06,9.06,0,0,1-1.45,3,6.7,6.7,0,0,1-1.17,1.21,7,7,0,0,1-1.42.88,10.78,10.78,0,0,1-3.16.87,25.16,25.16,0,0,1-3.24.2c1.07-.11,2.15-.24,3.2-.44a11,11,0,0,0,3-1,6.36,6.36,0,0,0,1.28-.89,6.18,6.18,0,0,0,1-1.15,8.5,8.5,0,0,0,1.24-2.84,21.75,21.75,0,0,0,.47-6.3,62.93,62.93,0,0,0-.67-6.39,121.15,121.15,0,0,1-1.2-12.92,39.3,39.3,0,0,1,.29-6.5,14.31,14.31,0,0,1,.84-3.16,6.86,6.86,0,0,1,.79-1.43A7,7,0,0,1,431,331.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.7,330.88a2.09,2.09,0,0,1,1,.44,5.47,5.47,0,0,1,.79.73,10.73,10.73,0,0,1,1.21,1.78,22.93,22.93,0,0,1,1.65,4,56,56,0,0,1,1.85,8.38,151.55,151.55,0,0,1,1.74,17,46.77,46.77,0,0,1-.41,8.6,17,17,0,0,1-1.19,4.21,11,11,0,0,1-2.61,3.53,24,24,0,0,1-7.35,4.5,36,36,0,0,1-8.26,2.21,39.18,39.18,0,0,0,8.08-2.64,24.33,24.33,0,0,0,7-4.6,10.77,10.77,0,0,0,2.38-3.33,16,16,0,0,0,1.05-4,46.63,46.63,0,0,0,.36-8.44c-.17-5.67-.83-11.33-1.51-17a63.66,63.66,0,0,0-1.57-8.35,22.52,22.52,0,0,0-1.44-4,9.83,9.83,0,0,0-1.1-1.81,5.25,5.25,0,0,0-.72-.77A2.09,2.09,0,0,0,431.7,330.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.67,336.85a14.06,14.06,0,0,1,1.32,1.9c.21.33.38.67.57,1s.35.67.52,1l-.78-.1c.24-.29.49-.58.75-.86s.51-.57.79-.83a14.21,14.21,0,0,1,1.74-1.53,12.82,12.82,0,0,1-1.18,2c-.21.32-.44.62-.67.93s-.47.6-.71.89l-.47.57-.32-.66c-.16-.35-.32-.69-.47-1s-.3-.71-.43-1.07A13.86,13.86,0,0,1,392.67,336.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.3,335.75a5.38,5.38,0,0,1,.2,1.35,8.28,8.28,0,0,1-.05,1.32,9.51,9.51,0,0,1-.26,1.29,5.28,5.28,0,0,1-.53,1.26,5.34,5.34,0,0,1-.21-1.35,8.34,8.34,0,0,1,.06-1.32,8.42,8.42,0,0,1,.26-1.29A5.46,5.46,0,0,1,395.3,335.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.25,401.79a14.58,14.58,0,0,1,1.53,1.73c.24.3.46.62.68.92l.64,1h-.79c.2-.32.42-.63.64-.94s.45-.62.69-.92a14.78,14.78,0,0,1,1.56-1.72,15.65,15.65,0,0,1-.94,2.12c-.17.35-.38.67-.56,1s-.4.66-.6,1l-.4.62-.4-.63c-.2-.32-.4-.65-.59-1s-.38-.66-.55-1A14.36,14.36,0,0,1,409.25,401.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.73,400.39a5.41,5.41,0,0,1,.36,1.32,8.26,8.26,0,0,1,.1,1.31,9.79,9.79,0,0,1-.11,1.32,5.53,5.53,0,0,1-.38,1.31,5.41,5.41,0,0,1-.36-1.32,8.26,8.26,0,0,1-.1-1.31,9.79,9.79,0,0,1,.11-1.32A5.53,5.53,0,0,1,411.73,400.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.29,321.9a13.7,13.7,0,0,1,.62,2.23c.08.38.13.75.2,1.13s.11.75.15,1.13l-.71-.35c.33-.19.66-.38,1-.56s.67-.36,1-.52a14.09,14.09,0,0,1,2.16-.86,14.64,14.64,0,0,1-1.78,1.49c-.31.23-.63.43-.94.65l-1,.61-.64.38-.07-.73c0-.38-.08-.76-.1-1.14s-.05-.77-.05-1.15A15,15,0,0,1,410.29,321.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.14,321.74a5.31,5.31,0,0,1-.26,1.34,8.25,8.25,0,0,1-1.17,2.35,5.08,5.08,0,0,1-.91,1,4.89,4.89,0,0,1,.25-1.34,8.25,8.25,0,0,1,1.17-2.35A5.13,5.13,0,0,1,413.14,321.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,361.63a15.86,15.86,0,0,1-.22,2.3c-.06.38-.14.75-.21,1.13s-.17.74-.26,1.11l-.54-.58,1.13-.17c.38,0,.76-.1,1.14-.12a13.78,13.78,0,0,1,2.32,0,13.87,13.87,0,0,1-2.19.76c-.37.11-.75.18-1.12.28l-1.12.22-.73.13.19-.71c.1-.37.2-.74.32-1.1s.22-.73.36-1.09A14.67,14.67,0,0,1,445,361.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.67,362.49a5.37,5.37,0,0,1-.71,1.16,9.23,9.23,0,0,1-.9,1,8.24,8.24,0,0,1-1,.82,5.82,5.82,0,0,1-1.22.62,5.21,5.21,0,0,1,.71-1.17,8.23,8.23,0,0,1,.9-1,7.5,7.5,0,0,1,1-.82A5.31,5.31,0,0,1,447.67,362.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.45,353.74a14.31,14.31,0,0,1,1.91,1.31c.3.23.59.49.88.73s.57.51.85.77l-.77.19c.12-.36.25-.72.39-1.07s.29-.71.45-1.06a14.39,14.39,0,0,1,1.1-2,15.29,15.29,0,0,1-.4,2.28c-.09.38-.2.74-.3,1.11s-.23.73-.35,1.09l-.24.7-.53-.51-.81-.81c-.26-.28-.53-.55-.78-.85A14.37,14.37,0,0,1,426.45,353.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.52,351.78a5.9,5.9,0,0,1,.67,1.19,8.56,8.56,0,0,1,.62,2.56,5.22,5.22,0,0,1-.05,1.36,5.64,5.64,0,0,1-.67-1.19,9.13,9.13,0,0,1-.41-1.25,9.51,9.51,0,0,1-.21-1.3A5.29,5.29,0,0,1,428.52,351.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.19,327.72A16.1,16.1,0,0,1,430.1,329c.3.23.58.49.88.73s.57.51.85.77l-.78.19c.13-.36.26-.72.4-1.07s.28-.71.45-1.06a15,15,0,0,1,1.1-2,15.29,15.29,0,0,1-.4,2.28c-.09.38-.2.74-.3,1.11s-.23.73-.35,1.09l-.24.7-.53-.51c-.28-.27-.55-.53-.82-.81s-.52-.55-.77-.85A13.5,13.5,0,0,1,428.19,327.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.26,325.77a5.64,5.64,0,0,1,.67,1.19,9.13,9.13,0,0,1,.41,1.25,9.51,9.51,0,0,1,.21,1.3,5.31,5.31,0,0,1-.05,1.37,5.45,5.45,0,0,1-.67-1.19,8.06,8.06,0,0,1-.41-1.26,9.27,9.27,0,0,1-.21-1.3A5.22,5.22,0,0,1,430.26,325.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.36,346.74a14,14,0,0,1,1.65,1.62c.26.28.5.58.74.87s.48.6.71.9l-.79.06q.27-.51.57-1c.21-.32.4-.65.62-1a14.65,14.65,0,0,1,1.44-1.83,14.1,14.1,0,0,1-.79,2.18c-.15.36-.33.69-.49,1s-.35.68-.53,1l-.36.65-.43-.6q-.34-.45-.66-.93c-.21-.32-.43-.63-.62-1A13.23,13.23,0,0,1,413.36,346.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.73,345.17a4.93,4.93,0,0,1,.46,1.28,8.44,8.44,0,0,1,.19,1.31,8.31,8.31,0,0,1,0,1.32,4.94,4.94,0,0,1-.28,1.33,4.93,4.93,0,0,1-.46-1.28,7.37,7.37,0,0,1-.18-1.31,8.31,8.31,0,0,1,0-1.32A5.85,5.85,0,0,1,415.73,345.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.89,355.55a14.4,14.4,0,0,1,2.29.38c.37.08.74.19,1.1.29s.73.22,1.1.34l-.62.5q-.06-.57-.09-1.14c0-.39-.05-.77,0-1.15a13.83,13.83,0,0,1,.13-2.31,14.7,14.7,0,0,1,.6,2.23c.08.38.13.76.19,1.13s.1.76.15,1.14l.07.73-.69-.24-1.08-.39c-.35-.14-.71-.27-1.06-.44A13.35,13.35,0,0,1,384.89,355.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.94,352.9a5.08,5.08,0,0,1,1.11.8,8.13,8.13,0,0,1,.9,1,7.52,7.52,0,0,1,.75,1.09,5.48,5.48,0,0,1,.53,1.26,5.08,5.08,0,0,1-1.11-.8,8.13,8.13,0,0,1-.9-1,8,8,0,0,1-.74-1.09A5.26,5.26,0,0,1,385.94,352.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.48,372.34a14.29,14.29,0,0,1,2.28.39c.38.08.74.19,1.11.29s.73.22,1.09.34l-.61.49c0-.38-.08-.76-.1-1.14s0-.76,0-1.14a14,14,0,0,1,.14-2.32,15.15,15.15,0,0,1,.6,2.24c.08.38.13.75.19,1.13s.1.76.14,1.14l.08.73-.7-.24c-.36-.12-.72-.25-1.07-.39s-.71-.28-1.06-.44A14.36,14.36,0,0,1,361.48,372.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.53,369.7a5.4,5.4,0,0,1,1.11.79,8.72,8.72,0,0,1,1.64,2.06,4.66,4.66,0,0,1,.53,1.25,6,6,0,0,1-1.11-.79,8.19,8.19,0,0,1-.89-1,7.52,7.52,0,0,1-.75-1.09A5.6,5.6,0,0,1,362.53,369.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.34,362.25a14.77,14.77,0,0,1,1.54,1.73c.25.3.46.61.69.92s.43.63.64,1h-.79c.2-.32.41-.64.64-1s.44-.63.68-.92a14,14,0,0,1,1.55-1.73,15.07,15.07,0,0,1-.93,2.13c-.17.34-.37.66-.55,1s-.4.65-.6,1l-.4.63-.39-.63c-.21-.32-.41-.64-.6-1s-.38-.66-.55-1A13.47,13.47,0,0,1,402.34,362.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,360.84a5,5,0,0,1,.37,1.32,8.17,8.17,0,0,1,.1,1.31,8.38,8.38,0,0,1-.1,1.32,5.07,5.07,0,0,1-.37,1.31,5.5,5.5,0,0,1-.37-1.31,8.38,8.38,0,0,1-.1-1.32,8.17,8.17,0,0,1,.1-1.31A5.93,5.93,0,0,1,404.81,360.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.45,406a15,15,0,0,1,2.29-.31c.39,0,.77,0,1.15-.05H381l-.44.66c-.15-.35-.3-.7-.43-1.06s-.27-.72-.37-1.08a13,13,0,0,1-.56-2.25,13.39,13.39,0,0,1,1.23,2c.19.33.35.68.52,1s.32.69.47,1l.3.68-.74,0-1.14-.06c-.38,0-.76-.05-1.14-.1A14.07,14.07,0,0,1,376.45,406Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.67,403.17a5.3,5.3,0,0,1,1.29.44,7.58,7.58,0,0,1,1.15.65,9,9,0,0,1,1,.82,5.33,5.33,0,0,1,.88,1.05,5.3,5.3,0,0,1-1.29-.44,6.82,6.82,0,0,1-1.15-.65,9,9,0,0,1-1-.82A5.33,5.33,0,0,1,376.67,403.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.73,365.68a14,14,0,0,1,1.55,1.73c.24.29.46.61.68.92s.44.63.64.94h-.79c.21-.32.42-.63.64-.94s.44-.63.69-.92a14.77,14.77,0,0,1,1.54-1.73,13.43,13.43,0,0,1-.92,2.12c-.17.35-.37.67-.56,1s-.39.65-.59,1l-.4.63-.4-.63c-.2-.32-.4-.64-.59-1s-.39-.66-.56-1A14.46,14.46,0,0,1,376.73,365.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.21,364.27a5.44,5.44,0,0,1,.37,1.32,8.17,8.17,0,0,1,.1,1.31,8.38,8.38,0,0,1-.1,1.32,5.5,5.5,0,0,1-.37,1.31,5.07,5.07,0,0,1-.37-1.31,8.38,8.38,0,0,1-.1-1.32,8.17,8.17,0,0,1,.1-1.31A5,5,0,0,1,379.21,364.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.35,377.79a15.08,15.08,0,0,1,.06,2.32c0,.38-.05.76-.07,1.14s-.08.76-.13,1.14l-.6-.51c.36-.11.73-.22,1.1-.31s.74-.19,1.12-.26a15.58,15.58,0,0,1,2.29-.31,14.29,14.29,0,0,1-2.08,1c-.35.15-.72.27-1.07.4s-.73.25-1.09.36l-.71.22.11-.73c.05-.38.1-.76.17-1.13s.14-.76.23-1.13A15.24,15.24,0,0,1,432.35,377.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.15,378.32a4.86,4.86,0,0,1-.57,1.24,8.31,8.31,0,0,1-.77,1.07,9.18,9.18,0,0,1-.93.94,5.52,5.52,0,0,1-1.14.76,5.87,5.87,0,0,1,.57-1.24,7.51,7.51,0,0,1,.78-1.07,7.43,7.43,0,0,1,.93-.93A5.36,5.36,0,0,1,435.15,378.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.49,389.59a14.68,14.68,0,0,1,1.54,1.72c.25.3.46.62.69.92s.43.63.64.95h-.79c.2-.32.42-.64.64-.95s.44-.62.68-.92a13.92,13.92,0,0,1,1.55-1.72,15,15,0,0,1-.93,2.12c-.17.35-.37.67-.55,1s-.4.65-.6,1l-.4.62-.39-.62c-.21-.32-.41-.64-.6-1s-.38-.66-.55-1A13.89,13.89,0,0,1,395.49,389.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,388.18a5,5,0,0,1,.37,1.31,8.38,8.38,0,0,1,.1,1.32,7.23,7.23,0,0,1-.1,1.31,5,5,0,0,1-.37,1.32,5.93,5.93,0,0,1-.37-1.32,8.26,8.26,0,0,1-.1-1.31,8.38,8.38,0,0,1,.1-1.32A5.85,5.85,0,0,1,398,388.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.75,387a14,14,0,0,1,1.55,1.73c.24.29.46.61.69.91s.43.63.64.95h-.8c.21-.32.42-.64.64-.95s.44-.62.69-.92A14.68,14.68,0,0,1,370.7,387a13.85,13.85,0,0,1-.92,2.12c-.17.35-.37.67-.56,1s-.39.65-.59,1l-.4.63-.4-.63c-.2-.32-.4-.64-.59-1s-.39-.66-.56-1A15,15,0,0,1,365.75,387Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.23,385.55a5.5,5.5,0,0,1,.37,1.31,8.38,8.38,0,0,1,.1,1.32,8.26,8.26,0,0,1-.1,1.31,5,5,0,0,1-.37,1.32,5,5,0,0,1-.37-1.32,8.26,8.26,0,0,1-.1-1.31,8.38,8.38,0,0,1,.1-1.32A5.5,5.5,0,0,1,368.23,385.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.22,360.47s-9,0-7.88-3.87c.38-1.35,4-.7,6.07,1.47-1.51-2.61-1.15-6.25.25-6.24C371.67,351.85,369.22,360.47,369.22,360.47Z",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.22,360.47s-9,0-7.88-3.87c.38-1.35,4-.7,6.07,1.47-1.51-2.61-1.15-6.25.25-6.24C371.67,351.85,369.22,360.47,369.22,360.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.22,360.47c-3.44,2.6-8.37,1.39-8.62-.57-.29-2.22,5.57-.89,5.57-.89s-5.06-4.31-2.67-6.12,5.15,4.25,5.15,4.25.33-6,2.39-5.12C372.85,352.8,372.66,357.87,369.22,360.47Z",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.54,337.2s-4.72-7.61-.86-8.74c1.34-.39,2.69,3,1.95,5.94,1.42-2.66,4.7-4.27,5.43-3.08C446.16,334.74,437.54,337.2,437.54,337.2Z",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.54,337.2s-4.72-7.61-.86-8.74c1.34-.39,2.69,3,1.95,5.94,1.42-2.66,4.7-4.27,5.43-3.08C446.16,334.74,437.54,337.2,437.54,337.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.54,337.2c-4-1.56-5.59-6.38-4.06-7.63,1.74-1.41,3.7,4.27,3.7,4.27s1-6.57,3.79-5.49-.9,6.61-.9,6.61,5.28-2.89,5.61-.67C446,336.24,441.57,338.75,437.54,337.2Z",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.05 421.45 426.63 421.45 421.74 462.07 382.94 462.07 378.05 421.45",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.05 421.45 379.15 430.61 425.8 428.37 426.63 421.45 378.05 421.45",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.99,
    y: 416.32,
    width: 54.69,
    height: 7.26,
    style: {
      fill: "#E7CFB6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.14,203.44a1.13,1.13,0,0,1-.76,1.29c-1.28.26-2.82.54-4.54.87-5.45-10.18-10.95-18.12-9.37-14.95a55.58,55.58,0,0,1,4.89,15.79c-2,.37-6.66,1.18-9,1.59-5.92-18.39-12.25-31.78-11.43-27.51,3.33,17.24,3,23,2.55,29.08-21.73,3.77-50.26,8.39-71,11.29-3.7-10.11-7.21-21.12-7.48-20.29-2.09,6.25-1.78,14.88-1,21.46-6.6.88-11.88,1.46-15.13,1.65,0,0-2.64-8.56-3.22-11.42a60.35,60.35,0,0,1-.44-22.22c1.28-7.58,4.26-14.5,7-21.56a.59.59,0,0,1,.07-.16s0,0,0-.06A62.17,62.17,0,0,0,187.16,154a.29.29,0,0,0,0-.11,59.69,59.69,0,0,0,.39-10.64c-.65-13,5.2-25,16.86-29.94,20.12-24.37,44.12-18.21,53.1-2.6.87,1.53,1.74,3.29,2.62,5.22l0,.06c3.27,7.14,6.57,16.52,9.44,23.73a0,0,0,0,0,0,0s0,0,0,.08v0a71.48,71.48,0,0,0,3.8,8.27C280.93,160.83,295.07,166.79,302.14,203.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.61,117.53c-7.41,5.13-11.51,11.79-11.56,21.33,0,5.56.28,10.95-1.18,16.38-1.49,5.6-4.38,10.4-7.36,15.22-4.73,7.64-7.77,15-7.49,24.36.29,9.47,2.13,20.45,6.38,28.78,0,.05.1,0,.07,0-3.67-8.53-5.27-20.77-4.86-30.24.45-10.41,5.41-17.54,10.34-26A42.8,42.8,0,0,0,190,145.43c0-4.72-.67-9.54.65-14.14,1.57-5.5,5.6-9.38,9.64-12.88A.56.56,0,0,0,199.61,117.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.58,160.84c-6.51-6.58-13.12-12.06-17.53-20.69-4-7.87-6.82-16.36-10.9-24.21a.11.11,0,1,0-.19.09c6.52,14,9.28,28.66,20.26,39.77,6,6,11.88,11.57,16.27,19.15a71.93,71.93,0,0,1,8.63,25.77c.05.33.46.25.45-.06A59.52,59.52,0,0,0,288.58,160.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,112.11c3.05-1.59,3.85-19.84-9-26.88-12.62-6.93-26.64,4.57-18.5,18.42C182,112.4,197.81,115.48,204.26,112.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.75,86.23a20.15,20.15,0,0,0-5.36,12.18,12.18,12.18,0,0,0,5,11.07c3.46,2.62,7.93,3.78,12.39,4.24a37.78,37.78,0,0,0,6.81,0,18.47,18.47,0,0,0,6.67-1.6,16.39,16.39,0,0,1-6.47,2.84,30.2,30.2,0,0,1-7.11.77,23.62,23.62,0,0,1-13.81-4.18,13.5,13.5,0,0,1-5.46-13.34A17.77,17.77,0,0,1,178.75,86.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3,216.44c41.45,30.9,98.3,100.53,92.25,117.34-6.74,18.71-64.51-24.66-64.77-27.67-.2-2.27-24.88-46.07-43.39-77.85S249.05,208.8,259.3,216.44Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.45,306.22c-2.28-4.74-35.57-62.39-45.37-80.73S236.7,200.19,259,215s74.11,67.55,88.69,97.53c14.05,28.89-1.57,31.28-24.3,20.44C304.72,324.07,286.45,306.22,286.45,306.22Z",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.64,215.76a4.58,4.58,0,1,1-4.58-4.58,4.94,4.94,0,0,1,.87.08h0c.84.45,1.69,1,2.59,1.52l0,0A4.53,4.53,0,0,1,256.64,215.76Zm28.23,47.3a4.58,4.58,0,1,0,4.58,4.57A4.58,4.58,0,0,0,284.87,263.06Zm28.56,2.9a4.43,4.43,0,0,0-.32,1.67,4.58,4.58,0,0,0,4.57,4.58,4.5,4.5,0,0,0,1.11-.14Q316.17,269,313.43,266Zm-45-28.18a4.58,4.58,0,1,0,4.58,4.58A4.58,4.58,0,0,0,268.47,237.78Zm49.21,77.16a4.58,4.58,0,1,0,4.58,4.57A4.57,4.57,0,0,0,317.68,314.94Zm31.24.29a4.57,4.57,0,0,0,1.57,8.86,4.45,4.45,0,0,0,1.56-.28A56.57,56.57,0,0,0,348.92,315.23Zm-47.64-25.57a4.58,4.58,0,1,0,4.58,4.58A4.58,4.58,0,0,0,301.28,289.66Zm31.83.1a4.58,4.58,0,1,0,4.92,6.81C336.49,294.35,334.84,292.07,333.11,289.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.27,334.16c-2.91,7.21-14.48,5.66-28.93-1.22-18.61-8.87-36.89-26.72-36.89-26.72-2.29-4.74-35.57-62.39-45.37-80.73-7-13.1-6.25-20.39,2.88-18.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.26,462.07H228.42c-4.17-16.36-10.58-41.54-16.17-63.47a.11.11,0,0,0,0-.05c-.34-1.34-.69-2.68-1-4-.22-.82-.42-1.63-.62-2.42-5.38-21.09-9.62-37.76-9.72-38.14s-.11-.42-.14-.56a2.9,2.9,0,0,1-.08-.32H293.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,353.08v0c0,.06,0,.17,0,.32,0,1.09,0,2.17,0,3.26,0,2.77-.17,5.55-.35,8.32a256.5,256.5,0,0,1-4.24,32.27,340.9,340.9,0,0,1-10.74,41.52c-.39,1.18-.62,1.84-.65,1.91l-7.38,3.65-.59.3c-4.81,2.38-10.74,5.33-14.61,7.26-2.06,1-3.54,1.76-3.95,2l-.12.06s-.16,3.29-.37,8.1H147.22c2-16.95,2.27-19.18,2.27-19.18-.59-3.27-3.2-11.71-2.27-21.49,2.06-21.53,15.26-64.75,16.46-67.32.28-.63.44-1,.44-1H189.4l59.9,0h40.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.65,453.69v.22c0,2.72-.08,5.45-.12,8.16h-1c.22-2.72.4-5.47.72-8.2,0-.25.05-.48.08-.73a.16.16,0,0,1,.31,0C247.64,453.33,247.65,453.51,247.65,453.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66,458.93c4.25-2.94,8.84-5.42,13.34-8s9.27-5.09,14.06-7.32c9.35-4.36,19.23-7.5,29.07-10.56.25-.07.41.33.17.44-9.48,4.07-18.67,8.74-28.1,12.92-4.74,2.1-9.52,4.12-14.27,6.21s-9.38,4.46-14.16,6.46A.11.11,0,0,1,235.66,458.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.6,412.54c.12-4.65.45-9.3.68-13.94.54-11,1-22,2-32.92a.34.34,0,0,1,.68,0c.14,8.48-.19,17-.36,25.46-.09,4.25-.21,8.49-.33,12.73a120.32,120.32,0,0,0-.08,12.16c.23,3.06.9,9,4.89,9.37,3.76.35,5.82-3.71,6.76-6.68,2.38-7.55,3.23-15.71,4-23.56.46-4.65.92-9.28,1.19-13.95s.65-11.65.4-16.35c0-.3.42-.29.47,0,.74,4,.77,12.21.67,17-.92,43.26-7.74,45.73-11.35,46.43a7.72,7.72,0,0,1-1.34.14c0,1-.17,2-.24,2.94-.11,1.54-.3,3.07-.51,4.6a33.7,33.7,0,0,1-.94,4.44,16.23,16.23,0,0,1-1.56,4.24.23.23,0,0,1-.43-.12,20.79,20.79,0,0,1,.36-4.38c.21-1.5.42-3,.73-4.48s.56-2.91.86-4.36c.2-1,.34-2,.52-3a7.15,7.15,0,0,1-5.32-4.19C261.64,420.64,261.5,416.42,261.6,412.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.24,404.33c6,.42,12,1.2,18.06.48A31.45,31.45,0,0,0,208,398.64c10-7.72,14.32-20.36,17-32.22a.21.21,0,0,1,.42.07c-1.13,10.28-3.34,20.91-10,29.19a32,32,0,0,1-10.59,8.72,31.1,31.1,0,0,1-14,2.89A67.67,67.67,0,0,1,174.14,405,.35.35,0,0,1,174.24,404.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,401.93c-1.68-.19-3.33-.05-5-1.29s-3.16-3.47-4.5-7.14c-2.9-8-4.33-20-5.28-31.08,0-.25-.13-.24-.12,0,.49,9.5,1.28,19.43,3.27,27.63a41.8,41.8,0,0,0,3.1,9c1.24,2.38,2.62,3.52,4,4a5.82,5.82,0,0,0,4.64-.46C306.18,402.52,306.15,402,306,401.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.17,356.07c-3.25,17.77-7.09,35.79-10.64,53.52-.91,5.3-2.49,10.53-2.17,15.93a110.7,110.7,0,0,0,2.57,16.16c-.57,3.42-1.13,6.84-1.74,10.26s-1.18,6.76-1.83,10.13c.31-3.42.7-6.83,1.07-10.24s.77-6.82,1.17-10.23a88.74,88.74,0,0,1-3-16,23.56,23.56,0,0,1,.13-5.63c1.08-7.28,2.6-14.38,4.12-21.51,3.1-14.23,6.51-28.39,10.37-42.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.64,354.48l-6.84-43.05s13.43-16.87,4.62-35.35c-4.45-9.37-31.12-55.8-47.29-67.26-15.17-10.76-39.6-3-46.34,8.65-17,29.39-26.71,64.35-36.54,137Z",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.83,215.76a4.58,4.58,0,1,1-4.58-4.58A4.58,4.58,0,0,1,223.83,215.76Zm25.36-3.56a4.57,4.57,0,1,0,6.24,6.65A82.53,82.53,0,0,0,249.19,212.2Zm-62.75,50.86a4.58,4.58,0,1,0,4.58,4.57A4.58,4.58,0,0,0,186.44,263.06Zm32.81,0a4.58,4.58,0,1,0,4.58,4.57A4.57,4.57,0,0,0,219.25,263.06Zm32.81,0a4.58,4.58,0,1,0,4.58,4.57A4.58,4.58,0,0,0,252.06,263.06Zm33.28,0-.47,0a4.58,4.58,0,1,0,4.14,6.52C288,267.66,286.73,265.47,285.34,263.08Zm-82.49-25.3a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,202.85,237.78Zm32.81,0a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,235.66,237.78Zm34,.16a4.27,4.27,0,0,0-1.19-.16A4.58,4.58,0,1,0,273,243C271.91,241.3,270.79,239.61,269.66,237.94Zm-83.22,77a4.58,4.58,0,1,0,4.58,4.57A4.57,4.57,0,0,0,186.44,314.94Zm32.81,0a4.58,4.58,0,1,0,4.58,4.57A4.56,4.56,0,0,0,219.25,314.94Zm32.81,0a4.58,4.58,0,1,0,4.58,4.57A4.57,4.57,0,0,0,252.06,314.94Zm32.81,0a4.58,4.58,0,1,0,4.58,4.57A4.57,4.57,0,0,0,284.87,314.94Zm-112-24.3c-.56,2.6-1.1,5.27-1.64,8a4.58,4.58,0,0,0,1.64-8Zm30-1a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,202.85,289.66Zm32.81,0a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,235.66,289.66Zm32.81,0a4.58,4.58,0,1,0,4.58,4.58A4.58,4.58,0,0,0,268.47,289.66ZM170,341.54a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,170,341.54Zm32.81,0a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,202.85,341.54Zm32.81,0a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,235.66,341.54Zm32.81,0a4.58,4.58,0,1,0,4.58,4.58A4.58,4.58,0,0,0,268.47,341.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5,300.58a139.65,139.65,0,0,0-20.39,3.77c-3.32.92-6.57,2-9.81,3.13-1.62.57-3.25,1.08-4.88,1.59a22.6,22.6,0,0,1-5.26,1.1.12.12,0,0,0,0,.24,39.16,39.16,0,0,0,5.08-.19,37.86,37.86,0,0,0,4.82-1c3.37-.9,6.7-2,10.06-2.9,6.78-1.88,13.56-3.77,20.47-5.16A.29.29,0,0,0,265.5,300.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.66,306.34a152.64,152.64,0,0,0-17.11-.48c-2.86.09-5.69.35-8.53.68q-2,.24-4,.54c-1.49.22-2.95.64-4.43.84-.16,0-.15.26,0,.25,1.4-.15,2.84-.06,4.26-.12l4.26-.2c2.85-.13,5.69-.22,8.54-.37,5.69-.31,11.36-.56,17.06-.67C283,306.81,283,306.37,282.66,306.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,209.55c.8,2.61,15.21,23.32,29.19,19.69,5.87-1.52,0-24.22,0-24.22l3.7-24.38-31.44-17S211.66,208.43,212,209.55Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.86,180.64l-3.6,23.66a48.88,48.88,0,0,1-28.48-23.83c.34-9.12.64-16.85.64-16.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.58,139c12.32,38.45-9.32,50.18-17.61,52.82-7.53,2.41-33.47,9.64-49.7-27.33S202,109.65,219,103.24,259.26,100.57,271.58,139Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.73,133.93a26,26,0,0,1-2.79.09,4.53,4.53,0,0,1-2.86-.45,1.43,1.43,0,0,1-.41-1.7,3.56,3.56,0,0,1,3.21-1.65,5.27,5.27,0,0,1,3.63,1A1.53,1.53,0,0,1,262.73,133.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66,144.34a26.31,26.31,0,0,1,2.51-1.21,4.46,4.46,0,0,1,2.8-.75,1.45,1.45,0,0,1,1.07,1.39,3.56,3.56,0,0,1-2.27,2.8,5.2,5.2,0,0,1-3.74.54A1.53,1.53,0,0,1,235.66,144.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.36,151.23c-.05-.09-.17.18-.14.29.8,2.63,1.27,5.78-.89,7.31-.07,0,0,.18.06.14C246.21,157.77,245.54,153.6,244.36,151.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.24,149.1c-4.36.83-2.38,9.48,1.66,8.71S244.89,148.41,241.24,149.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.65,149.94c-.65.67-1.19,1.7-2.08,2s-2-.38-2.92-1.09c-.09-.08-.15,0-.13.13.36,1.66,1.38,3.22,3.22,3.06,1.67-.15,2.5-1.88,2.53-3.64C240.28,150.07,239.91,149.68,239.65,149.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.84,146.48c0-.1.23.08.25.2.51,2.7,1.55,5.71,4.17,6.07.08,0,.1.14,0,.15C261.21,153.14,259.88,149.13,259.84,146.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.61,143.15c4.25-1.28,6.5,7.31,2.56,8.49S258.06,144.22,261.61,143.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.55,143.25c.8.28,1.69.93,2.51.77s1.41-1.3,1.78-2.34c0-.11.12-.06.15.06.48,1.63.38,3.48-1.11,4.2s-2.79-.46-3.61-2C263.12,143.66,263.23,143.14,263.55,143.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.47,172.13c.76.52,1.57,1.27,2.56,1.18a7.39,7.39,0,0,0,2.79-1.21.1.1,0,0,1,.14.12,3.71,3.71,0,0,1-3.17,2.09,2.92,2.92,0,0,1-2.56-2C248.16,172.15,248.36,172.05,248.47,172.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09,168.54c4.18-2.43,6.51-2.31,9.28-2.83.28-.14.88-.57.84-.86v0c0-.1-1.91-5.41-1.91-5.41.83.13,5,.61,4.63-.4-3.21-8.33-6.79-17.6-11.76-25.22a.25.25,0,0,0-.44.22c2.77,8.13,7,15.72,9.88,23.85a16,16,0,0,0-4.5.06c-.25.17,2.31,5.62,2.5,6.53,0,0-4.37-.38-9,3.7C248.59,169.07,248.57,169.42,250.09,168.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.47,167.86c7.55-1.11,4.77-18.34,4.77-18.34s29.62-13.92,25.21-40c0,0,9.82,14.65,28.13,17.42,0,0-8.81-27.45-32.31-26.71,0,0-30.06-2.34-39.38,23.59S204.4,168.61,209.47,167.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,107.66a28.57,28.57,0,0,1,1.83,11.94,29.9,29.9,0,0,1-3,11.85,24.46,24.46,0,0,1-1.51,2.68l-.79,1.32c-.3.42-.62.82-.94,1.22-.65.8-1.26,1.62-1.94,2.38s-1.46,1.43-2.21,2.13c-.37.34-.73.71-1.12,1l-1.22.91-2.44,1.81c-1.73,1-3.51,2-5.29,2.91,1.57-1.27,3.24-2.37,4.76-3.64l2.23-2,1.11-1c.34-.35.66-.73,1-1.1.65-.73,1.31-1.46,2-2.17s1.16-1.57,1.74-2.35l.87-1.18.73-1.26a23.57,23.57,0,0,0,1.4-2.56,34.1,34.1,0,0,0,3.27-11.17,36.27,36.27,0,0,0,.24-5.9A35,35,0,0,0,239,107.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.58,162.75s-11.38-10.33-16.26-6,5.63,20.68,12.73,21.63a6.83,6.83,0,0,0,8.11-5.61Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.45,161.36a.1.1,0,0,0,0,.19c5,.81,8.4,4.52,11.1,8.55-1.75-1.39-3.83-1.9-5.73.24-.1.11.06.28.18.22a4.21,4.21,0,0,1,4.83.4,20.83,20.83,0,0,1,3,3.16c.31.36,1,0,.73-.46l-.06-.1C214.28,167.68,207.87,160.52,201.45,161.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.35,208.26s11.62,25.51,15.11,28.32,31.5-.63,32-3S242,208.12,242,208.12s-10.82-4.57-19.87-4.34C212.77,204,208.35,208.26,208.35,208.26Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.37,333.38c-7.87,11.9-23.33,16.77-78.53,29.05-7.63,1.69-39.36-45.79-32.09-49.93,9.67-5.52,51.69-14.26,54.69-14.52C318.81,295.72,354.71,325.32,349.37,333.38Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.35,309.85s-23.23,8.72-34,17.09c-14.44,11.19-22.3,26.8-25.19,33.55-6.05,14.07-11,52.27-.19,55.6,9.74,3,12.77-36.29,12.77-36.29s-9.71,39.57,2.69,41,13.31-44.35,13.31-44.35-9.06,40.87,4,40.37c9.84-.38,13-41.84,13-41.84s-7.54,35.19,2.59,35.23c11.2.05,16.53-38,16.53-38,25.79-4.22,36.34-16.78,42.78-26.61C295.17,343.24,245.35,309.85,245.35,309.85Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.21,365.9c-1.31,4.61-2.67,9.26-3.56,14s-1.62,9.45-2.08,14.22c-1.1,11.69,0,19.19,0,18.72-.46-11.13,2.48-28,3.37-32.74s1.55-9.44,2.44-14.14C201.41,365.81,201.24,365.79,201.21,365.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.26,368.82c-1.41,6-3,11.81-4.19,17.83s-1.71,11.77-2.44,17.83c-.06.46.21.34.28-.13,1-6,2.34-11.5,3.38-17.51s1.86-12,3.12-18C218.43,368.75,218.28,368.73,218.26,368.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.35,368.7c-2.63,9-3.6,18.45-4.33,27.75,0,.47.3.27.36-.2,1.27-9.26,2.19-16.53,4.28-27.46C233.7,368.62,233.4,368.51,233.35,368.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.82,306.48,296.37,360s48.85-12.53,55.77-25.32c4.56-8.42-33.33-41-61.16-36.33Z",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.09,317.33l-1.62-1.7A4.48,4.48,0,0,1,256.09,317.33Zm28.78-2.39a4.58,4.58,0,1,0,4.58,4.57A4.57,4.57,0,0,0,284.87,314.94Zm32.81,0a4.58,4.58,0,1,0,4.58,4.57A4.57,4.57,0,0,0,317.68,314.94Zm-19.12-17a4.53,4.53,0,0,0,2.72.9,4.58,4.58,0,0,0,1.89-.41A43.22,43.22,0,0,0,298.56,297.92Zm2.72,43.62a4.58,4.58,0,1,0,4.58,4.58A4.58,4.58,0,0,0,301.28,341.54Zm32.81,0a4.58,4.58,0,0,0-3.75,7.21c2.85-1.18,5.62-2.43,8.19-3.72A4.56,4.56,0,0,0,334.09,341.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.42,350.57c-5.18-6.11-10.68-11.93-16.21-17.75s-11-11.64-16.71-17.32c-3.2-3.2-6.38-6.43-9.7-9.53-.09-.08-.24,0-.16.14,5.17,6.1,10.66,12,16.13,17.8s11,11.65,16.64,17.39c3.17,3.25,6.39,6.43,9.71,9.53C309.28,351,309.58,350.75,309.42,350.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.25,308l-2.08-1.55-.24-.18c6.32-1.79,12.69-3.42,19.11-4.81,11.09-2.27,22.34-4.71,33.71-4.63a51.83,51.83,0,0,1,23.12,7.29,62,62,0,0,0-23.16-5.56,105.65,105.65,0,0,0-14.29,1.36c-11.08,1.59-26.93,4.6-38.11,6.57l.06-.27,1.88,1.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,247.07c3.7,60,18.94,105.93,44.16,105.58,16.76-.23,5.11-49.67,4.92-50.74a261.92,261.92,0,0,0-23.81-65.38C201.23,201.91,192.61,220.26,194.26,247.07Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,247.07c3.7,60,18.94,105.93,44.16,105.58,16.76-.23,12.7-42.8,12.5-43.86-.68-3.64-14.75-40.79-31.39-72.26C201.23,201.91,192.61,220.26,194.26,247.07Z",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.83,267.63a4.58,4.58,0,1,1-4.58-4.57A4.58,4.58,0,0,1,223.83,267.63Zm-21-29.85a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,202.85,237.78Zm16.4,77.16a4.58,4.58,0,1,0,4.58,4.57A4.56,4.56,0,0,0,219.25,314.94Zm32.11.06a4.57,4.57,0,0,0,.09,9.05C251.54,320.68,251.48,317.54,251.36,315Zm-48.51-25.34a4.6,4.6,0,0,0-3.28,1.38q.74,3.81,1.55,7.44a4.52,4.52,0,0,0,1.73.34,4.58,4.58,0,0,0,0-9.16Zm32.81,0a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,235.66,289.66Zm0,51.88a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,235.66,341.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59,240.53c5.4,10.55,10.39,21.3,15.28,32.09,4.71,10.87,9.63,21.7,13.13,33C241.41,284,230.7,262,221.59,240.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.05,242.83c1.47,3,2.61,6.4,2.16,9.76-.58-3.25-1.68-6.47-2.16-9.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.46,349.07c15.46-3.95,37.75-41.83,50.12-83.87,2.36-8-60.44-33.3-62-24.51-4.91,28.2-16.26,65.56-13.63,87.68C224,345.56,236.76,351.8,247.46,349.07Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,208.71c-4.26-4.29-6.11-17.28-10.28-24.64s-14.51-10-16-7,1.4,5.59,3.45,18.14c1.31,8.08-3.32,24.92.77,39.4C242,241.91,266.27,213,262,208.71Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,208.71c-4.26-4.29-6.11-17.28-10.28-24.64s-14.51-10-16-7,1.4,5.59,3.45,18.14c1.31,8.08-3.32,24.92.77,39.4C242,241.91,266.27,213,262,208.71Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,208.71c-4.26-4.29-6.11-17.28-10.28-24.64s-14.51-10-16-7,1.4,5.59,3.45,18.14c1.31,8.08-3.32,24.92.77,39.4C242,241.91,266.27,213,262,208.71Z",
    style: {
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.84,166.14c5.82,4.45-6.39,17.86-6.39,17.86a13.54,13.54,0,0,1,9.2.17c5.1,2.23,3.85,11.21,3.85,11.21a16.64,16.64,0,0,1,9.67,1.71c4.67,2.63,4.69,11.87,4.69,11.87a14.66,14.66,0,0,1,7.56,6.87c4,8.51-4.74,20-8.72,28.24-4.27,8.78-9.63,19.69-12.78,25.15l-60-23.51s5.53-44.67,12.56-52.9C253.42,185.87,279,159.32,287.84,166.14Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,184c-8.07,5.86-14.72,13.65-21.05,21.23-.14.17.13.39.27.22,6.21-7.62,14.6-13.75,21.1-21.11C281.7,184.14,281.41,183.84,281.2,184Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.75,195.13a25.8,25.8,0,0,0-4.46,5.14c-1.45,1.92-2.86,3.87-4.25,5.84-2.77,3.95-5.46,8-8,12-.12.19.13.4.26.22,2.77-3.93,5.6-7.81,8.54-11.62q2.21-2.87,4.45-5.68a31.62,31.62,0,0,0,4-5.52A.35.35,0,0,0,293.75,195.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.74,209.12c-1.6,1.14-2.68,3.24-3.76,4.84-1.23,1.83-2.47,3.64-3.71,5.45-2.5,3.63-5,7.24-7.61,10.78-.13.17.13.39.27.21,2.67-3.57,5.4-7.11,8.05-10.71q1.95-2.66,3.87-5.32c1.09-1.51,2.62-3.28,3.08-5.13A.13.13,0,0,0,308.74,209.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.45,168.66c-7,5.12-13.25,11.25-19.54,17.2a92.53,92.53,0,0,0-6.71,7,30.65,30.65,0,0,0-4.38,8.51c-.79,2-1.43,4.1-2.06,6.19,1-5.31,2.21-11,5.48-15.45a73.14,73.14,0,0,1,6.69-7.27c6.36-5.94,12.87-12,20.52-16.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.85,257.86,286.26,302s-24.92,50.69-38.8,51.09-29.72-7.06-31.85-40.32C215.07,304.47,224.85,257.86,224.85,257.86Z",
    style: {
      fill: "#E7CFB6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.83,267.63a4.58,4.58,0,0,1-1.68,3.55c.41-2.08.8-4,1.14-5.71A4.64,4.64,0,0,1,223.83,267.63Zm-4.58,47.31a4.53,4.53,0,0,0-3.34,1.46c.24,2.5.58,4.84,1,7a4.47,4.47,0,0,0,2.35.66,4.58,4.58,0,1,0,0-9.15Zm32.81,0a4.58,4.58,0,1,0,4.58,4.57A4.57,4.57,0,0,0,252.06,314.94Zm-16.4-25.28a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,235.66,289.66Zm36.89,2.51-3.42-2.46a4.89,4.89,0,0,0-.66,0,4.58,4.58,0,1,0,4.58,4.58A4.52,4.52,0,0,0,272.55,292.17Zm-36.89,49.37a4.58,4.58,0,1,0,4.57,4.58A4.58,4.58,0,0,0,235.66,341.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.23,278.47c3,2,5.82,4.34,8.69,6.55s5.72,4.46,8.54,6.74q8.46,6.83,16.81,13.8c1.52,1.28,3,2.55,4.53,3.86s3,3,4.64,4.36a.13.13,0,0,1-.16.2c-1.41-1.09-3-2-4.4-3.06s-2.94-2.24-4.39-3.39q-4.26-3.37-8.49-6.79c-5.65-4.54-11.27-9.13-16.76-13.86-3.1-2.67-6.31-5.28-9.25-8.13A.18.18,0,0,1,226.23,278.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.81,262.86,224.74,258l.31-.12c-2,12-4.27,24-6.35,36a156.76,156.76,0,0,0-2.18,15.7,83.74,83.74,0,0,0,1.91,20.3,63.7,63.7,0,0,1-3.54-20.32c.49-11.49,3.06-22.77,5.38-34q2-9.07,4.47-18.06l.23.17,6.84,5.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,300.67l1.87,1.32,0,0c-3.37,7.26-7.1,14.34-11.1,21.28-6.27,10.17-12.45,21-22.25,28.31-3.34,2.51-7.78,3-11.88,3.08a27.15,27.15,0,0,1-12-2.36c-11.33-5.43-17-17.67-21-28.88-5.18-15.18-8.3-30.89-11.23-46.61-1.35-7.87-2.66-15.74-3.67-23.66,1.46,7.84,2.95,15.68,4.63,23.47,3.29,15.56,6.81,31.17,12,46.19,3.94,10.72,9.42,22.45,20.1,27.76a25.45,25.45,0,0,0,11.21,2.27c3.8-.13,7.73-.35,10.94-2.71,9.56-7.06,16-17.49,22.34-27.39,4.21-6.64,8.2-14,11.88-20.68l-1.81-1.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67,258.63s-.6,2.84,3.42,7.82",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.68,462.07c127.06-.61,269.58-.62,396.64,0-127.06.62-269.58.61-396.64,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.13,111.73a4.51,4.51,0,1,0,4.51-4.51A4.51,4.51,0,0,0,274.13,111.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.13,111.73a4.26,4.26,0,0,0,8.52,0,4.26,4.26,0,0,0-8.52,0Zm0,0c.18-6.28,9.31-6.33,9.52,0-.21,6.32-9.34,6.27-9.52,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.74,
    cy: 108.02,
    r: 6.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.25,108c-.08,5.58,7.06,8.39,10.78,4.29a6.26,6.26,0,0,0,0-8.58c-3.72-4.09-10.86-1.29-10.78,4.29Zm0,0a6.75,6.75,0,1,1,11.39,4.9,6.77,6.77,0,0,1-11.39-4.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 353.11,
    cy: 84.68,
    rx: 51.86,
    ry: 38.61,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.67,75.71c-6,18.53,7.7,35.34,24.24,42.13a67.17,67.17,0,0,0,51.94-.11c10.71-4.59,20.58-12.87,24.22-24.23,7.71-25.62-18.13-43.87-40.9-46.57-22.65-3.2-51.22,5.43-59.5,28.78Zm0,0c8.25-23.42,36.79-32.19,59.57-29.28C374.06,48,385.8,52.5,394.51,60.84,403.36,69,408,82.1,404,93.81c-10.46,29.2-51.56,36-77.23,24.32-16.48-7-30.2-23.86-24.12-42.42Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbol--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.14,87.77v3.81a2.8,2.8,0,0,1-2.87,2.88,2.88,2.88,0,0,1-2.87-2.88v-6.1c0-.06.06-.06.06-.11s-.06-.06-.06-.12a3,3,0,0,1,2.87-2.88,6.57,6.57,0,1,0,0-13.14,6.46,6.46,0,0,0-5.63,3.23,2.88,2.88,0,0,1-4,1.05,2.85,2.85,0,0,1-1-3.92,12.33,12.33,0,1,1,13.49,18.18Zm0,12.85v1a2.8,2.8,0,0,1-2.87,2.88,2.88,2.88,0,0,1-2.87-2.88v-1a2.92,2.92,0,0,1,2.87-2.88A2.84,2.84,0,0,1,355.14,100.62Z",
    style: {
      fill: "#E7CFB6"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreYouSure);
export default __webpack_public_path__ + "static/media/are-you-sure.964a44ea7f67362bcf94fc0f621d8702.svg";
export { ForwardRef as ReactComponent };